import { Injectable } from '@angular/core';
import {SharedService} from "../../shared/shared.service"
import {TermDataService} from "./term.data.service";

@Injectable({
  providedIn: 'root'
})
export class TermService {

  constructor(
    public sharedService: SharedService,
    public termDataService: TermDataService,
  ) {}

  getTerms = () => {
    return this.termDataService.list();
  }
}
